import {InventoryActionType, warehouseList} from "../../actions/inventory/inventoryAction";
import commonReducer from "../common/CommonReducer";
import { v4 as uuidv4 } from 'uuid';


const DefaultInventoryState = {
    productList:[],
    kitList:[],
    productTotal:0,
    productStateList:[],
    productCategoryList:[],
    warehouseList:[],
    packageList:[],
    currentProduct:null,
    batchSearchList:[],
    productSearchList:[],
    kitProductList:[],
    packageFilterList:[],
    customerFilterList:[],
    mapList:[],
    platformList:[],
    ownerList:[],
    ownerInfo:{},
    ownerCarrierList:[],
    areaCodeList:[]
}

export const inventoryReducer = ( state = DefaultInventoryState, action = {}) =>
{
    switch (action.type) {
        case InventoryActionType.PRODUCT_FILTER:
            return { ...state, productList: action?.payload?.rows?action?.payload?.rows.map((item, index) => {
                    return { ...item, id: uuidv4() }; // 使用展开语法创建新对象，并添加ID属性
                }):[], productTotal: action.payload.total?action.payload.total:0}

        case InventoryActionType.KIT_FILTER:
            return { ...state, kitList: action?.payload?.rows?action?.payload?.rows.map((item, index) => {
                    return { ...item, id: uuidv4() }; // 使用展开语法创建新对象，并添加ID属性
                }):[], productTotal: action.payload.total?action.payload.total:0}

        case InventoryActionType.PRODUCT_CATEGORY_LIST:
            return { ...state, productCategoryList: action.payload}

        case InventoryActionType.PRODUCT_STATE_LIST:
            return { ...state, productStateList: action.payload}

        case InventoryActionType.WAREHOUSE_LIST:
            return {...state,warehouseList:action.payload}

        case InventoryActionType.PACKAGE_LIST:
            return {...state,packageList: action.payload}

        case InventoryActionType.PLATFORM_LIST:
            return {...state,platformList: action.payload}

        case InventoryActionType.CURRENT_PRODUCT:
            return {...state,currentProduct: action.payload}

        case InventoryActionType.BATCH_SEARCH_LIST:
            return { ...state, batchSearchList: action?.payload?.rows?action?.payload?.rows.map((item, index) => {
                    return { ...item, id: uuidv4() }; // 使用展开语法创建新对象，并添加ID属性
                }):[]}

        case InventoryActionType.PRODUCT_SEARCH_LIST:
            return { ...state, productSearchList:action?.payload?.rows?action?.payload?.rows.map((item, index) => {
                    return { ...item, id: uuidv4() }; // 使用展开语法创建新对象，并添加ID属性
                }):[], productTotal: action.payload.total?action.payload.total:0}

        case InventoryActionType.SKU_CHOICE_PRODUCT:
            return { ...state, kitProductList: action.payload}

        case InventoryActionType.MAP_LIST:
            return { ...state, mapList:action?.payload?.rows?action?.payload?.rows.map((item, index) => {
                    return { ...item, id: uuidv4() }; // 使用展开语法创建新对象，并添加ID属性
                }):[], productTotal: action.payload.total?action.payload.total:0}

        case InventoryActionType.PACKAGE_SEARCH_LIST:
            return { ...state, packageFilterList:action?.payload?.rows?action?.payload?.rows.map((item, index) => {
                    return { ...item, id: uuidv4() }; // 使用展开语法创建新对象，并添加ID属性
                }):[], productTotal: action.payload.total?action.payload.total:0}

        case InventoryActionType.CUSTOMER_SEARCH_LIST:
            return { ...state, customerFilterList:action?.payload?.rows?action?.payload?.rows.map((item, index) => {
                    return { ...item, id: uuidv4() }; // 使用展开语法创建新对象，并添加ID属性
                }):[], productTotal: action.payload.total?action.payload.total:0}


        case InventoryActionType.OWNER_LIST:

            return { ...state, ownerList:action?.payload?.rows?.map((item, index) => {
                    return { ...item, id: uuidv4() }; // 使用展开语法创建新对象，并添加ID属性
                }), productTotal: action.payload.total?action.payload.total:0}

        case InventoryActionType.OWNER_INFO:
            return { ...state, ownerInfo:action?.payload.data}

        case InventoryActionType.OWNER_INFO_RESET:
            return { ...state, ownerInfo:{}}

        case InventoryActionType.AREA_CODE: {
            // 1. 利用 Map 去重，根据 country + countryCode 组合作为 key
            const deduplicated = Array.from(
                new Map(
                    action.payload.map(item => [
                        `${item.country}_${item.countryCode}`, // key
                        item                                   // value
                    ])
                ).values()
            );

            // 2. 映射为你想要的格式
            const areaCodeList = deduplicated.map(item => ({
                ...item,
                label: item.country,
                value: item.countryCode
            }));

            return {
                ...state,
                areaCodeList,
            };
        }
        // case InventoryActionType.OWNER_CARRIERS_LIST:
        //     return { ...state, ownerCarrierList:action?.payload}

        default:
            return state;

    }

}
